import styled from 'styled-components';

export const Container = styled.div`
  .ql-editor .ql-italic {
    font-style: italic;
  }
`;
